import React, { useContext, useState } from 'react';
import MainStore from '../stores/MainStore';
import { downloadUboDeclaration } from '../Utils/UkPrefill';
import UkDocumentUpload, { documentButtonStyle, DOCUMENT_COLORS } from './UkDocumentUpload';

const UkUboDeclaration = ({ id, value, onChange }) => {
  const mainStore = useContext(MainStore);
  const [failed, setFailed] = useState(false);

  const download = async () => {
    setFailed(false);
    try {
      await downloadUboDeclaration(mainStore);
    } catch (error) {
      setFailed(true);
    }
  };

  return (
    <UkDocumentUpload
      id={id}
      title="Beneficial Ownership (UBO) Declaration"
      required
      description="Signed declaration of every individual owning 25% or more or otherwise exercising control. The PSC register alone does not satisfy CDD (MLR 2017 reg 28(9))."
      value={value}
      onChange={onChange}
      hasError={failed}
      errorMessage="The UBO Declaration could not be downloaded. Please try again."
      extraAction={
        <button type="button" style={documentButtonStyle(DOCUMENT_COLORS.orange, DOCUMENT_COLORS.orange)} onClick={download}>
          Download pre-filled PDF
        </button>
      }
    />
  );
};

export default UkUboDeclaration;
